import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { HStack, Text, Heading } from '@library';
import BrandImage from '../../../brand/components/BrandImage';
import type { Product } from '../../types';
import styles from './ProductHeader.module.scss';

const ProductHeader = ({
    selectedSku,
    product,
}: {
    selectedSku?: string;
    product: Product;
}) => {
    const { name, manufacturer, manufacturerLogo } = product;
    const skuLabel = !selectedSku ? (
        <FormattedMessage id="please make a choice" />
    ) : (
        selectedSku
    );
    return (
        <HStack align="center" justify="spaceBetween" gap="small" wrap>
            <div>
                <div className={styles.itemNo}>
                    <Text primary>
                        <Text medium>
                            <FormattedMessage id="Common ItemNumber" />:
                        </Text>
                        &nbsp;
                        {skuLabel}
                    </Text>
                </div>
                <Heading h3>{name}</Heading>
            </div>
            {manufacturerLogo && (
                <BrandImage
                    url={manufacturerLogo}
                    size="100px"
                    aspectRatio={1 / 2}
                    alt={manufacturer}
                />
            )}
        </HStack>
    );
};

export default memo(ProductHeader);
